import { render, staticRenderFns } from "./WyswygInput.vue?vue&type=template&id=0b15cb81&"
import script from "./WyswygInput.vue?vue&type=script&lang=js&"
export * from "./WyswygInput.vue?vue&type=script&lang=js&"
import style0 from "./WyswygInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports